export default __webpack_public_path__ + "static/media/newEvents.89bb4f36.png";